function Spoiler() {
  this.init();
}

Spoiler.prototype = {
  init() {
    $(document).on('click', '[data-old-spoiler-btn]', this.handler);
  },

  destroy() {
    $(document).off('click', '[data-old-spoiler-btn]', this.handler);
  },

  handler(e) {
    e.preventDefault();

    const $trigger = $(this);
    const $wrap = $trigger.closest('[data-old-spoiler]');
    const $content = $wrap.find('[data-old-spoiler-content]');
    const $expandBtns = $wrap.find('[data-old-spoiler-btn=expand]');
    const $collapseBtns = $wrap.find('[data-old-spoiler-btn=collapse]');

    const isCollapsed = !$content.is(':visible');
    const action = $trigger.data('spoiler-btn');
    const config = $wrap.data('spoiler');

    function toggleSpoilerBlink(state) {
      if (state) {
        $expandBtns.animate(
          {
            opacity: 'hide',
          },
          300,
          () => {
            $content.animate({
              opacity: 'show',
            }, 300);
            $collapseBtns.animate({
              opacity: 'show',
            }, 300);
          },
);
      } else {
        $content.animate({
          opacity: 'hide',
        }, 300);
        $collapseBtns.animate(
          {
            opacity: 'hide',
          },
          300,
          () => {
            $expandBtns.animate({
              opacity: 'show',
            }, 300);
          },
);
      }
    }

    if (config.type === 'blink') {
      // TODO: different animation types
    }

    if (action === 'collapse' && !isCollapsed) {
      toggleSpoilerBlink(false);
      return;
    }

    if (action === 'expand' && isCollapsed) {
      toggleSpoilerBlink(true);
      return;
    }

    toggleSpoilerBlink(!isCollapsed);
  },
};

export default new Spoiler();
